import { reactive } from 'vue';
export default {
    namespaced: true,
    state() {
      return reactive({
        base: '', // 初期値
        routeConfigs: [],  // ルート設定
        filteredRoutes: [],
        islandDetails: {},
        searchQuery: '',
        selectedLanguage: 'ja',
        currentPage: 1,
        pageSize: 10,
      });
    },
    mutations: {
      setBase(state, base) {
        state.base = base;
      },
      setRoutes(state, routes) {
        // console.log("island.js setRoutes()");
        // state.routeConfigs = routes;
        // state.filteredRoutes = routes;
        state.routeConfigs = [...routes]; // 新しい配列を作成して代入
        state.filteredRoutes = [...routes]; // 新しい配列を作成して代入
      },
      setFilteredRoutes(state, routes) {
        // console.log("island.js setFilteredRoutes()");
        // console.log("island.js setFilteredRoutes() routes = " + JSON.stringify(routes)); // OK
        // state.filteredRoutes = routes; // フィルタリングされたルートの保存
        state.filteredRoutes = [...routes]; // 新しい配列を作成して代入
      },
      setIslandDetails(state, { islandName, data }) {
        // console.log("island.js setIslandDetails()");
        // console.log("island.js setIslandDetails() islandName = " + islandName + " / data = " + JSON.stringify(data));
        // 島ごとの詳細情報を保存
        state.islandDetails[islandName] = data;
        // 島ごとの詳細情報をリアクティブに保存
        // Vue.set(state.islandDetails, islandName, data);
        // console.log("island.js setIslandDetails() end stat.islandDetails = " + JSON.stringify(state.islandDetails));
      },
      // setIslandDetails(state, { islandName, data }) {
      //   console.log("island.js setIslandDetails() islandName = " + islandName + " / data = " + JSON.stringify(data));
      //   console.log("island.js setIslandDetails() islandName = " + islandName + " / islandDetails = " + JSON.stringify(this.islandDetails));

      //   state.islandDetails = {
      //     ...state.islandDetails,  // 既存のislandDetailsを保持
      //     [islandName]: data  // 新しいプロパティを追加
      //   };
      //   // reactive.set(state.islandDetails, islandName, data);  // Vue.setを使用してリアクティブに更新
      //   console.log("island.js setIslandDetails() end, state.islandDetails = ", JSON.stringify(state.islandDetails));
      // },
      setItem(state, item) {
        state.item = item;
      },
      setSearchQuery(state, query) {
        state.searchQuery = query;
      },
      setSelectedLanguage(state, language) {
        state.selectedLanguage = language;
      },
      setCurrentPage(state, page) {
        // console.log("island.js setCurrentPage()");
        state.currentPage = page;
      }
    },
    actions: {
      initializeBase({ commit }, base) {
        commit('setBase', base);
      },
      async fetchRoutes({ commit }) {
        // console.log("island.js fetchRoutes()");
        try {
          const response = await fetch('./pub/routes.json');
          if (!response.ok) {
            throw new Error('Failed to fetch routes');
          }
          // console.log("island.js fetchRoutes() fetch() end");
          const routes = await response.json();
          commit('setRoutes', routes);  // ここでcommitを使用
          commit('setFilteredRoutes', routes); // 初期値として全ルートを設定
        } catch (error) {
          console.error('Error fetching routes:', error);
        }
      },
      async fetchIslandDetails({ commit }, islandName) {
        // console.log("island.js fetchIslandDetails()");
        try {
            const response = await fetch(`./pub/data/${islandName}.json`);
            if (!response.ok) {
                throw new Error('Failed to fetch island details');
            }
            const data = await response.json();
            commit('setIslandDetails', { islandName, data });
        } catch (error) {
            console.error('Error fetching island details:', error);
        }
      },
        /*
        async fetchItem({ commit }, fileName) {
          try {
            const response = await fetch(`/data/${fileName}.json`);
            if (!response.ok) {
              throw new Error(`Failed to fetch item: ${response.statusText}`);
            }
            const item = await response.json();
            commit('setItem', item);  // ここでcommitを使用
          } catch (error) {
            console.error('Error fetching item:', error);
          }
        },
        */
      filterData({ commit, state }) {
        // console.log("Filter data method called with searchQuery:", this.searchQuery);  // Track search query before filtering
        // searchQuery が定義されているか確認
        const searchQuery = state.searchQuery || '';

        const filtered = state.routeConfigs.filter(route => 
          route.name.includes(searchQuery) || 
          route.prefecture.includes(searchQuery) ||
          route.address.includes(searchQuery)
        );
        commit('setFilteredRoutes', filtered);
      },
      updateSearchQuery({ commit, dispatch }, query) {
        // console.log("Updated search query in Vuex:", query);  // Confirm update
        commit('setSearchQuery', query);
        dispatch('filterData');
      }
    },
    getters: {
      base: (state) => state.base,
      paginatedData: (state) => {
            if (!Array.isArray(state.filteredRoutes)) {
                console.error('filteredRoutes is not an array:', state.filteredRoutes);
                return [];
            }
            // currentPageとperPageを使ってページネーションを行う
            // console.log("island.js getters: state.filteredRoutes = "+JSON.stringify(state.filteredRoutes));
            // console.log("island.js getters: pageSize = "+JSON.stringify(state.pageSize));
            const start = (state.currentPage - 1) * state.pageSize;
            // console.log("island.js getters: state = "+JSON.stringify(state.filteredRoutes.slice(start, start + state.pageSize)));
            return state.filteredRoutes.slice(start, start + state.pageSize);
      },
      pageCount: (state) => {
            if (!Array.isArray(state.filteredRoutes)) {
                console.error('filteredRoutes is not an array:', state.filteredRoutes);
                return 0;
            }
            return Math.ceil(state.filteredRoutes.length / state.pageSize);
      },
      islandDetails: (state) => (islandName) => {
        return state.islandDetails[islandName] || {};
      }
    }
  };